import RequestAbstract from "./RequestAbstract";

export default class Packages extends RequestAbstract {
    get link() {
        return this.links.packages;
    }
}
